import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="customerAttributes";

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}


export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function selectOne(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectOne/${parameter}`,
    method: 'get',
  })
}



export default {
  insert,
  update,
  selectOne
}